package com.castly.admin.ui

import androidx.compose.runtime.*
import com.castly.admin.api.ApiClient
import com.castly.admin.ui.tags.TagListPage
@Composable
fun TagsSection(apiClient: ApiClient) {
    TagListPage(apiClient)
}
